export default __webpack_public_path__ + "static/media/LAS0720.34I-37963_-22248_0.d1ba9de3.jpg";